import React from 'react';

import Ggr from './Ggrs/Ggr';
import GgrLinear from './Ggrs/GgrLinear';
import GgrMargin from './Ggrs/GgrMargin';
import DetailedBreakdown from './Tables/DetailedBreakdown';
import WageredLinear from './Wagered/WageredLinear';

function CasinoDashboard() {
    const getContent = () => {
        return (
            <div>
                <div className="dashboard-blocks-container">
                    <Ggr />
                    <GgrMargin />
                </div>
                <div className="dashboard-blocks-container">
                    <GgrLinear />
                    <WageredLinear />
                </div>
                <div className="dashboard-block-container">
                    <DetailedBreakdown />
                </div>
            </div>
        );
    };
    return getContent();
}

export default CasinoDashboard;
